import React, { useState, useEffect } from 'react';
import propTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import InputSelect from '../../../../components/library/inputSelect';
import { fetchPlanStatusTypes } from '../../../../../actions/lookupActions';

function PlanStatusSelect(props) {
  const dispatch = useDispatch();
  const planStatusTypes = useSelector(state => state.lookup.allPlanStatusTypes);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (!planStatusTypes.planStatusTypes) {
      dispatch(fetchPlanStatusTypes());
    } else {
      setOptions(
        planStatusTypes.planStatusTypes.map(item => {
          return { label: item.attributes.name, value: item.id };
        }),
      );
    }
  }, [planStatusTypes]);

  return (
    <>
      {planStatusTypes && planStatusTypes.planStatusTypes && (
        <InputSelect {...props} options={options} />
      )}
    </>
  );
}

PlanStatusSelect.propTypes = {
  errorMessage: propTypes.string,
  labelText: propTypes.string,
  helpText: propTypes.string,
  placeholder: propTypes.string,
  isRequired: propTypes.bool,
};


PlanStatusSelect.defaultProps = {
  errorMessage: '',
  labelText: 'PLAN STATUS',
  helpText: '',
  placeholder: '',
  isRequired: false,
};

export default (PlanStatusSelect);
